import React from 'react'
import { useSelector } from '~/store/hooks'

import { TwitterX } from '~/icons/Twitter'
import { Linkedin } from '~/icons/Linkedin'
import { Facebook } from '~/icons/Facebook'

const SocialCard = ({ social, list = false, seo = false }) => {
  const lang = useSelector((state) => state.lang)
  const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' }
  let IconComponent, accountUrl
  let message = social?.message

  if (!seo) {
    const content = document.createElement('div')
    content.innerHTML = message
    const quote = content.querySelector('.j-twitter-quote')

    if (quote) {
      content.removeChild(quote)
    }

    message = content.outerHTML
  }

  if (social?.source?.source === 'LinkedIn') {
    IconComponent = Linkedin
    accountUrl = `https://www.linkedin.com/company/${social?.source?.term}`
  } else if (social?.source?.source === 'X (Twitter)') {
    IconComponent = TwitterX
    accountUrl = `https://www.twitter.com/${social?.source?.term}`
  } else {
    IconComponent = Facebook
    accountUrl = `https://www.facebook.com/${social?.source?.term}`
  }

  const smart_substr = (str, len) => {
    var temp = str.substr(0, len)
    if (temp.lastIndexOf('<') > temp.lastIndexOf('>')) {
      temp = str.substr(0, 1 + str.indexOf('>', temp.lastIndexOf('<')))
    }
    return temp
  }

  if (
    social?.source?.source === 'LinkedIn' ||
    social?.source?.source === 'Facebook'
  ) {
    message =
      message.length > 280 ? smart_substr(message, 279) + '&hellip;' : message
  }

  return (
    <div
      className={`card social-card social-card--${social?.source?.source?.toLowerCase()} ${list ? 'social-card--list' : ''}`}
    >
      <a
        className="social-card__read-more"
        href={social?.full_url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="sr-only">Read more</span>
      </a>
      <div className="social-card__header">
        <div
          className={`social-card__icon ${list ? 'social-card__icon--list' : ''}`}
        >
          <IconComponent className="icon-blue text-black" />
        </div>
        <div className="font-semi-bold">
          <a href={accountUrl} rel="noopener noreferrer" target="_blank">
            @
            {social?.source?.name !== null
              ? social?.source?.name
              : social?.source?.term}
          </a>
          <p className="text-14 mt-1">
            {new Date(social?.external_created_at).toLocaleDateString(
              lang,
              dateOptions,
            )}
          </p>
        </div>
      </div>

      <div className="social-card__content">
        <div
          className={`font-bold text-base ${!list ? 'md:text-18 lg:text-20' : 'md:text-14 lg:text-base'} leading-regular`}
          dangerouslySetInnerHTML={{ __html: message }}
        ></div>
      </div>
    </div>
  )
}

export default SocialCard
